import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from "prop-types";
import TableTotalsBar from "../../../Components/Table/RecordTotalsBar";

const BookingsTotalsBar = (props) => {

    const bookingCounts = useSelector(state => state.module.BOOKINGS.bookingList[props.view][props.scope].bookingCounts);

    return (
        <TableTotalsBar
            leftItems={[
                {label: 'Today', value: bookingCounts['today'] ?? '...'},
                {label: 'Due', value: bookingCounts['due'] ?? '...'},
                {label: 'In Progress', value: bookingCounts['in-progress']?? '...'},
            ]}
            rightItems={[
                {label: 'Tomorrow', value: bookingCounts['tomorrow'] ?? '...'},
                {label: 'Next 7 Days', value: bookingCounts['next-7-days'] ?? '...'},
            ]}
        />
    );
};

BookingsTotalsBar.propTypes = {};

BookingsTotalsBar.defaultProps = {};

export default BookingsTotalsBar;
